import React from 'react';
import Navigation from '../components/Navigation';
import Dashboard from '../components/Dashboard';
import './Home.css';

const Home = () => {

  return (
    <div>
      <Navigation />
      <div className="content">
      <Dashboard />
      </div>
    </div>
  );
};

export default Home;
